import React from 'react'

export default function({onClick}){
    return(
        <button className="active" onClick={onClick}>еще раз</button>
    )
}